/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Members_BlurbInputs */



/**
* | output |
* | --- |
* | "The members area is where administrators manage everyone in the organization, viewing roles and activity, inviting new people, and setting access." |
*
* @param {Uno_Edu_Intro_Members_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_members_blurb = /** @type {((inputs?: Uno_Edu_Intro_Members_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Members_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Mitgliederbereich ist der Ort, an dem Administratoren alle in der Organisation verwalten, Rollen und Aktivität einsehen, neue Personen einladen und Zugriff festlegen.")
	return /** @type {LocalizedString} */ ("The members area is where administrators manage everyone in the organization, viewing roles and activity, inviting new people, and setting access.")
});